import { useMemo } from 'react';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import { citations } from '@Constants';

const useEditInQueryBuilderButtonAttrs = ({ context, whereClauseImportToken } = {}) => {
  return useMemo(() => {
    if (
      context === citations &&
      whereClauseImportToken &&
      whereClauseImportToken.indexOf('CBI.BICIT') > -1 &&
      Auth.isFeatureEnabled(FEATURES.enableEditSynonyms)
    ) {
      return {
        label: 'Edit Synonyms',
        className: 'e2e-edit-qb e2e-edit-synonyms',
      };
    }
    return {
      label: 'Edit in Query Builder',
      className: 'e2e-edit-qb',
    };
  }, [context, whereClauseImportToken]);
};

export default useEditInQueryBuilderButtonAttrs;
